/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CommandOrder, CommandResource } from '@alfa-client/command-shared';
import { HistorieItemHeaderComponent } from '@alfa-client/historie-shared-ui';
import { getUserName, UserProfileResource } from '@alfa-client/user-profile-shared';
import { Component, input } from '@angular/core';

@Component({
  selector: 'alfa-historie-item-assign-user',
  templateUrl: './historie-item-assign-user.component.html',
  styleUrls: ['./historie-item-assign-user.component.scss'],
  imports: [HistorieItemHeaderComponent],
})
export class HistorieItemAssignUserComponent {
  readonly command = input.required<CommandResource>();
  readonly userProfile = input<UserProfileResource>();

  get headline(): string {
    return this.buildHeadline(this.userProfile());
  }

  buildHeadline(userProfile: UserProfileResource): string {
    if (this.command().order === CommandOrder.ASSIGN_USER) {
      return `${getUserName(userProfile)} den Vorgang zugewiesen.`;
    }
    if (this.command().order === CommandOrder.UNASSIGN_USER) {
      return 'die Zuweisung des Bearbeiters auf "Nicht zugewiesen" versetzt.';
    }
  }
}
